<template>
	<div v-loading="loading" class="base_scroll_page">
		<!-- 滚动区域 -->
		<div class="b_scroller">
			<!-- action -->
			<div style="font-size: 0;text-align: right;">
				<el-button type="primary" @click="handleAddClick">上传数据</el-button>
			</div>
			<!-- action end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="id"
						label="excelId"
					>
					</el-table-column>
					<el-table-column
						label="excel文件名称"
						width="400"
					>
						<template slot-scope="scope">
							<el-link :href="scope.row.link">{{ scope.row.name }}</el-link>
						</template>
					</el-table-column>
					<el-table-column
						prop="time"
						label="时间"
					>
					</el-table-column>
					<el-table-column
						label="操作"
						width="200"
					>
						<template slot-scope="scope">
							<el-button
								@click="handleViewClick(scope.row)"
							>查看</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination
						layout="total, prev, pager, next, jumper"
						next-text="下一页" 
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange">
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
		<!-- 滚动区域 end -->
		
		<!-- 新增弹框 -->
		<add v-model="add_display" @onSuccess="getList"></add>
		<!-- 新增弹框 end -->
		
		<!-- 查看弹框 -->
		<view-box v-model="view_display" :excelId="view_id"></view-box>
		<!-- 查看弹框 end -->
	</div>
</template>

<script>
	import Api from '../../../../../api/index.js';
	import Add from './components/add.vue';
	import ViewBox from './components/view.vue';
	
	export default {
		mounted () {
			this.getList();
		},
		data () {
			return {
				loading: false,
				tableData: [],
				currentPage: 1,
				total: 0,
				
				add_display: false,
				
				view_display: false,
				view_id: ''
			}
		},
		methods: {
			/****************************** @Events *****************************/
			// 点击上传数据
			handleAddClick() {
				this.add_display = true;
			},
			// 点击查看
			handleViewClick(row) {
				this.view_id = row.id;
				this.view_display = true;
			},
			// 页码改变
			handlePageChange (page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.getList();
				}
			},
			
			/****************************** @Function *****************************/
			// 请求数据
			getList() {
				const that = this;
				that.loading = true;
				var requestData = {
					pageNum: that.currentPage,
					pageSize: 10
				};
				Api.findExcel(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						let list = [];
						that.total = res.data.data.total;
						res.data.data.records.forEach(v => {
							list.push({
								id: v.rechargeExcelId,
								link: v.rechargeExcel,
								name: v.rechargeExcel.split('/')[v.rechargeExcel.split('/').length - 1],
								time: v.createTs.split(' ')[0]
							});
						});
						that.tableData = list;
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		components: {
			Add,
			ViewBox
		}
	}
</script>

<style>
</style>
